export default {"src":"/_next/static/media/missing-profile-image.d45286a3.svg","height":97,"width":97};